<template>
  <div v-if="info.storeInfo">
    <div class="item-detail-show">
      <div class="item-detail-left">
        <div class="item-detail-big-img">
          <pic-zoom :url="bigImage" :scale="2.5"></pic-zoom>
        </div>
        <div class="item-detail-img-row">
          <div class="img-box">
            <div
              class="item-detail-img-small"
              v-for="(item, index) in info.storeInfo.images"
              :key="index"
              @mouseover="showBigImg(item)"
            >
              <img :src="item" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="item-detail-right">
        <div class="item-detail-title">
          <p>
            {{ info.storeInfo.title }}
          </p>
        </div>
        <div class="price-box">
          <div class="fight-box">
            <div class="fight-btn">
              <div>拼团价</div>
            </div>
            <div class="price-project">
              <div class="fight-price">
                ￥<span>{{ info.storeInfo.price }}</span>
              </div>
              <div class="old-price">￥{{ info.storeInfo.product_price }}</div>
            </div>
          </div>
          <div class="sale-box">
            <div>已团{{ info.storeInfo.sales }}件</div>
            <div>库存{{ info.storeInfo.stock }}件</div>
          </div>
          <div class="fight-num">{{ info.storeInfo.people }}人团</div>
        </div>
        <div class="fight-method">
          <div class="tip">拼团玩法</div>
          <div class="img">
            <img src="@assets/pc/images/activities/kaituan.png" alt="" />
          </div>
        </div>
        <div class="attr-box">
          <div class="item">
            通用名: <span>{{ info.storeInfo.general_name }}</span>
          </div>
          <div class="item">
            生产商: <span>{{ info.storeInfo.Authorized_holder }}</span>
          </div>
          <div class="item">
            国&nbsp;&nbsp;&nbsp;&nbsp;家:
            <span>{{ info.storeInfo.country }}</span>
          </div>
        </div>
        <div class="add-buy-car-box">
          <div class="add-buy-car">
            <span class="num">数量</span>
            <div class="input-box">
              <div class="del" @click="delNum">
                <Icon type="minus-round"></Icon>
              </div>
              <input type="search" v-model="count" @input="changeNum()" />
              <div class="add" @click="addNum">
                <Icon type="plus-round"></Icon>
              </div>
            </div>
            <span>件</span>
          </div>
          <div class="btn-box">
            <Button
              type="error"
              size="large"
              @click="goToBuy(info.storeInfo.product_id)"
              class="goto-buy btn"
              >单独购买</Button
            >
            <Button
              type="error"
              size="large"
              @click="addShoppingCartBtn()"
              class="btn"
              >立即开团</Button
            >
          </div>
        </div>
        <div class="share">
          <span>分享到:</span>
          <share :config="config"></share>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { postCartAdd } from "@api/user";
import PicZoom from "vue-piczoom";
export default {
  name: "GroupGoods",
  props: ["info"],
  components: {
    PicZoom
  },
  data() {
    return {
      price: 0,
      count: 1,
      imgIndex: 0,
      b_image: "",
      productSelect: {},
      uniqueId: "",
      attrCart: "", // 商品选中的属性
      config: {
        url: "", // 网址，默认使用 window.location.href
        source: "", // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
        title: "", // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
        description: "", // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
        image: "", // 图片, 默认取网页中第一个img标签
        sites: ["qq", "weibo", "wechat"], // 启用的站点
        wechatQrcodeTitle: "邀请好友一起拼团", // 微信二维码提示文字
        wechatQrcodeHelper:
          "<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>"
      }
    };
  },
  watch: {
    info() {
      if (this.info) {
        this.config.url =
          "http://mo.droga.cn/activity/group_rule/" + this.info.storeInfo.id;
        this.config.title = this.info.storeInfo.title;
        this.config.image = this.info.storeInfo.image;
        // console.log(this.info);
        // let value = [];
        // this.info.productAttr.forEach((element, index1) => {
        //   element.index = 0;
        //   value.push(this.info.productAttr[index1].attr_values[0]);
        // });
        // let selectID = value.sort().join(',');
        // this.attrCart = selectID;
        // for (var i in this.info.productValue) {
        //   if (selectID === i) {
        //     this.uniqueId = this.info.productValue[i].unique;
        //   }
        // }
      }
    }
  },
  computed: {
    // 药品主图的放大
    bigImage() {
      if (this.b_image) {
        return this.b_image;
      }
      return this.info.storeInfo.image;
    }
  },
  methods: {
    // 主图图片
    showBigImg(item) {
      this.b_image = item;
    },
    addShoppingCartBtn() {
      const data = {
        cartNum: this.count,
        new: "1", // 购买类型 0加入购物车 1立即购买
        productId: this.info.storeInfo.product_id,
        uniqueId: this.uniqueId,
        combinationId: this.info.storeInfo.id
      };
      postCartAdd(data)
        .then(
          res => {
            if (res.status === 200) {
              this.$router.push({
                path: "/order/" + res.data.cartId
              });
            }
          },
          err => {
            this.$Modal.warning({
              content: err.msg
            });
          }
        )
        .catch(err => {
          this.$Modal.warning({
            content: err.msg
          });
        });
    },
    goToBuy(id) {
      this.$router.push({
        path: "/detail/" + id
      });
    },
    changeNum() {
      if (this.count !== 1) {
        this.count = 1;
        this.$Modal.warning({
          content: "每人限购1件"
        });
      }
    },
    delNum() {
      if (this.count !== 1) {
        this.count--;
      }
    },
    addNum() {
      this.$Modal.warning({
        content: "每人限购1件"
      });
    }
  }
};
</script>

<style scoped>
/******************商品图片及购买详情开始******************/
.item-detail-show {
  width: 80%;
  margin: 15px auto;
  display: flex;
  flex-direction: row;
  background-color: #fff;
  padding: 15px;
}
.item-detail-left {
  width: 350px;
  margin-right: 30px;
}
.item-detail-big-img {
  width: 350px;
  height: 350px;
  box-shadow: 0px 0px 8px #ccc;
  cursor: pointer;
}
.item-detail-big-img >>> .magnifier-box.vertical img {
  width: 100%;
  /* height: 100%; */
}
.item-detail-img-row {
  margin-top: 15px;
}
.img-box {
  white-space: nowrap;
  overflow-x: auto;
}
.item-detail-img-small {
  width: 68px;
  height: 68px;
  box-shadow: 0px 0px 8px #ccc;
  cursor: pointer;
  display: inline-block;
  margin-right: 8px;
}
.item-detail-img-small:last-child {
  margin-right: 0;
}
.item-detail-img-small img {
  width: 100%;
  height: 100%;
}
/*商品选购详情*/
.item-detail-right {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.item-detail-title p {
  color: #333;
  font-size: 20px;
  font-weight: 700;
  height: 56px;
  display: -webkit-box !important;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.price-box {
  padding: 10px 20px;
  background: #f9f9f9;
  position: relative;
  overflow: hidden;
  width: 100%;
}
.price-box .fight-box {
  display: flex;
}
.price-box .fight-box .fight-btn div {
  line-height: 24px;
  width: 60px;
  background: #f8303d;
  border-radius: 14px;
  text-align: center;
  color: #fff;
  margin-top: 14px;
}
.price-box .price-project div {
  font-weight: 700;
  font-size: 16px;
  display: inline-block;
}
.price-box .fight-box .fight-price {
  color: #323232;
  margin-left: 10px;
}
.price-box .fight-box .old-price {
  color: #ccc;
  text-decoration: line-through;
}
.price-box .fight-box .fight-price span {
  font-size: 34px;
}
.price-box .fight-num {
  position: absolute;
  top: 10px;
  right: -30px;
  width: 100px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background: #f1381c;
  color: #fff;
  transform: rotate(45deg);
}
.sale-box {
  margin-left: 72px;
  margin-bottom: 10px;
}
.sale-box div {
  display: inline-block;
  width: 70px;
  height: 28px;
  background: #ffede9;
  color: #c85d6f;
  line-height: 28px;
  text-align: center;
  margin-right: 10px;
}
.fight-method {
  margin-top: 10px;
}
.fight-method .tip {
  margin-left: 20px;
  color: #666;
  position: relative;
  font-size: 16px;
}
.fight-method .tip:before {
  content: "";
  display: inline-block;
  width: 10px;
  height: 16px;
  background: #f1411c;
  position: absolute;
  top: 4px;
  left: -20px;
}
.fight-method .img {
  margin: 20px 0;
  text-align: center;
}
.attr-box {
  display: flex;
  flex-wrap: wrap;
  border-top: 1px dotted #ccc;
  padding-top: 10px;
}
.attr-box .item {
  width: 40%;
  color: #c9c9c9;
  font-size: 16px;
}
.attr-box .item span {
  color: #666;
}
.add-buy-car-box {
  width: 100%;
  margin-top: 5px;
  display: flex;
}
.add-buy-car {
  margin-top: 15px;
  margin-bottom: 10px;
}
.add-buy-car .num {
  font-size: 14px;
  margin-right: 10px;
  color: #999999;
}
.add-buy-car .input-box {
  display: inline-block;
  border: 1px solid #ccc;
  line-height: 28px;
  border-radius: 2px;
  margin-right: 10px;
}
.add-buy-car .input-box input {
  background: none;
  border: none;
  width: 50px;
  text-align: center;
  color: #3c3c3c;
  font-size: 14px;
}
.add-buy-car .input-box .del,
.add {
  display: inline-block;
  width: 40px;
  text-align: center;
  font-size: 14px;
  background: #ededed;
  cursor: pointer;
}
.btn-box {
  margin-left: 144px;
  margin-top: 10px;
}
.btn {
  padding: 6px 25px;
  font-size: 16px;
  font-weight: 700;
  background: #ec3f15;
}
.goto-buy {
  color: #fff;
  background: #ffa00e;
  margin-right: 15px;
  border: none;
}
.share {
  margin-top: 10px;
  display: flex;
}
.share span {
  line-height: 40px;
  margin-right: 10px;
  color: rgb(158, 158, 158);
  font-size: 14px;
}
</style>
